import api from './api';

export const getListNotify = (url, page, type) => {
  const params = {
    page,
    itemsPerPage: 10,
    type,
  };
  return api().get(url, { params });
};
